import * as React from 'react';
import moment from 'moment';

import { Avatar, AvatarSize } from 'wix-ui-tpa/Avatar';
import { Text, TYPOGRAPHY } from 'wix-ui-tpa/Text';
import { RoleBadges } from '@wix/social-groups-common';

import styles from './AuthorInfo.st.css';
import {
  withTpaComponentsConfig,
  WithTpaComponentsConfigProps,
} from '../../Context/withTpaComponentsConfig';
import { ApiTypes } from '@wix/social-groups-api/dist/src/types';

interface AuthorInfoProps {
  avatarUrl: string;
  name: string;
  timeStamp: Date;
  relationship: ApiTypes.v1.RelationshipWithGroup;
  roles: ApiTypes.v1.RoleInGroup[];
}

export const AuthorInfoComponent: React.FC<AuthorInfoProps &
  WithTpaComponentsConfigProps> = ({
  avatarUrl,
  name,
  timeStamp,
  mobile,
  relationship,
  roles,
}) => (
  <div {...styles('root', { mobile })}>
    <Avatar
      size={mobile ? AvatarSize.medium : AvatarSize.large}
      src={avatarUrl}
      className={styles.avatar}
    />
    <div>
      <Text typography={TYPOGRAPHY.listText}>{name}</Text>
      <span className={styles.relationship}>
        <RoleBadges relationship={relationship} roles={roles} />
      </span>
      <br />
      <Text {...styles('timestamp')}>{moment(timeStamp).fromNow()}</Text>
    </div>
  </div>
);

export const AuthorInfo = withTpaComponentsConfig(AuthorInfoComponent);
